import React from 'react';
import styled from 'styled-components';

import Anchor from '../Anchor';
import Column from '../Column';
import Row from '../Row';

import IconShopLoggedIn from '../../assets/svgs/header/shop-logged-in.svg';
import IconShoppingCartDesktop from '../../assets/svgs/header/shop.svg';
import IconShoppingCartMobile from '../../assets/svgs/header/mobile-shop.svg';

const SCIconShopLoggedIn = styled(IconShopLoggedIn)`
  vertical-align: middle;
`;

const SCIconShoppingCartMobile = styled(IconShoppingCartMobile)`
  vertical-align: middle;
`;

const SCIconShoppingCartDesktop = styled(IconShoppingCartDesktop)`
  vertical-align: middle;
`;

const ShoppingCart = ({ isLoggedIn, url }) => (
  <Anchor href={url} ariaLabel="Shopping Cart">
    <Row>
      <Column sm={12} lg={false}>
        <SCIconShoppingCartMobile width={24} height={24} />
      </Column>
    </Row>
    <Row>
      <Column sm={false} lg={12}>
        {isLoggedIn ? (
          <SCIconShopLoggedIn width={40} height={40} />
        ) : (
          <SCIconShoppingCartDesktop width={128} height={40} />
        )}
      </Column>
    </Row>
  </Anchor>
);

export default ShoppingCart;
